export default {
    breadcrumb: {
        create: 'Criar',
        edit: 'Editar',
    },

    activation: {
        index: 'categorias/:category_id/ativacoes',
        create: 'categorias/:category_id/ativacoes/criar',
        edit: 'categorias/:category_id/ativacoes/editar',

        breadcrumb: {
            index: 'Ativações',
            create: 'Criar ativação',
            edit: 'Editar ativação',
            category: {
                edit: 'Editar categoria',
            },
        },
    },

    address: {
        index: 'parceiros/:reseller_id/enderecos',
        create: 'parceiros/:reseller_id/enderecos/criar',
        edit: 'parceiros/:reseller_id/enderecos/editar',
    },

    bill: {
        index: 'faturas',
        show: 'faturas',
    },

    category: {
        index: 'categorias',
        create: 'categorias/criar',
        edit: 'categorias/editar',

        breadcrumb: {
            index: 'Categorias',
        },
    },

    erpWebhook: {
        index: 'erp-webhooks',

        breadcrumb: {
            index: 'Erp Webhooks',
        },
    },

    landingPage: {
        index: 'paginas-de-captacao',
        create: 'paginas-de-captacao/criar',
        edit: 'paginas-de-captacao/edit',
        breadcrumb: {
            index: 'Páginas de Captação',
        },
    },

    mail: {
        index: 'configuracoes/emails',
        edit: 'configuracoes/emails/editar',
    },

    partner: {
        index: 'parceiros',
    },

    period: {
        index: 'periodos',

        breadcrumb: {
            index: 'Períodos',
        },
    },

    popup: {
        index: 'configuracoes/popups',
        create: 'configuracoes/popups/criar',
        edit: 'configuracoes/popups/editar',

        breadcrumb: {
            index: 'Popups',
            create: 'Criar Popup',
            edit: 'Editar Popup',
        },
    },

    product: {
        index: 'produtos',
        create: 'produtos/criar',
        edit: 'produtos/editar',

        breadcrumb: {
            index: 'Produtos',
        },
    },

    productSale: {
        index: 'vendas',
        create: 'vendas/criar',
        edit: 'vendas/editar',

        breadcrumb: {
            index: 'Vendas',
        },
    },

    lead: {
        index: 'prospects',
        create: 'prospects/criar',
        show: 'prospects/visualizar',
        edit: 'prospects/editar',
        breadcrumb: {
            index: 'Prospects',
            show: 'Visualizar Prospect',
            edit: 'Editar Prospect',
        },
    },

    reports: {
        bills: 'relatorios/faturas',
        bookings: 'relatorios/bookings',
        resellers: 'relatorios/parceiros',

        breadcrumb: {
            bookings: 'Relatório de Bookings',
        },
    },

    rule: {
        index: 'categorias/:category_id/regras',
        create: 'categorias/:category_id/regras/criar',
        edit: 'categorias/:category_id/regras/editar',

        breadcrumb: {
            index: 'Regras',
            create: 'Criar regra',
            edit: 'Editar regra',
            category: {
                edit: 'Editar categoria',
            },
        },
    },

    settings: {
        index: 'configuracoes/',
        create: 'configuracoes/criar',
        edit: 'configuracoes/editar',

        breadcrumb: {
            index: 'Configurações do Sistema',
            create: 'Criar configuração',
            edit: 'Editar configuração',
        },
    },
    notifications: {
        index: 'notificacoes',
        create: 'notificacoes/criar',
        edit: 'notificacoes/editar',

        breadcrumb: {
            index: 'Notificações',
            create: 'Criar notificação',
            edit: 'Editar notificação',
        },
    },
}
